import React from 'react';
import "../../assets/css/modal.css"
import InformationError from "../Icons/InformationError";
import CancleCircle from "../Icons/CancelCircle";

function ErrorModalWindow(props) {

    function closeModal(e) {
        e.stopPropagation();
        props.result(1);
    }

    return (
        <>
            <div className="darkBG lightBG">
                <div className="modal-content model-content-alert">
                    <div className="modal-header modal-header-alert-error">
                        <div className="row background-1 w-100">
                            <div className="col-1">
                                <div className="modal-heading-title">
                                    <InformationError className="sidebar-icon-form" color="var(--white)"/>
                                </div>
                            </div>
                            <div className="col-10">
                                <div className="modal-heading-title ps-3 pe-3">
                                    {props.heading}
                                </div>
                            </div>
                            <div className="col-1">
                                <div className="modal-heading-title" onClick={closeModal}>
                                    <CancleCircle className="sidebar-icon-form" color="var(--white)"/>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="modal-body modal-overflow">
                        {props.children}
                    </div>
                    <div className="modal-footer">
                        <div className="margin-left">
                            <button type="button" className="button-solid button-transparent-active modal-button"
                                    onClick={closeModal}>
                                 Cancel
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default ErrorModalWindow;
